export default {
  'aws.title': 'Amazon注文',
  'aws.business': '製品/注文ID',
  'aws.orderStatus': '注文ステータス',
  'aws.aswStatus': '登録ステータス',
  'aws.orderInfo': '注文情報',
  'aws.expireTime': '有効期限',
  'aws.createTime': '作成時間',
  'aws.pending': '有効化保留中',
  'aws.unbind': 'リンク保留中',
  'aws.bound': 'リンク済み',
  'aws.cancelled': 'キャンセル済み',
  'aws.activeText': '{time} 後に有効化',
  'aws.operate': '操作',
  'aws.bindTips': '注文が有効化保留中のため、操作できません',
  'aws.bind': 'バインド',
  'aws.engageLabOrder': 'EngageLab注文',
  'aws.whatsapp.recharge': 'リチャージ',
  'aws.whatsapp.recharge.price': 'リチャージ金額',
  'aws.apppush.dataCenter': 'データセンター',
  'aws.apppush.dau': 'DAU',
  'aws.apppush.vip': 'VIP期間',
  'aws.email.tips': 'メールパッケージ/トラフィック/独立 IP',
  'aws.email': 'メール数',
  'aws.email.ip': '独立 IP 数',
  'aws.email.flow': 'トラフィックチャージ',
  'aws.choose.service': 'EngageLabサービスを選択',
  'aws.choose.organization': '組織',
  'aws.choose.nodata': '利用可能なアプリがありません',
  'aws.choose.whatsapp': 'ビジネスアカウント',
  'aws.choose.app': 'アプリ',
  'aws.order.title': 'Amazon注文を紐付け',
  'aws.order.information': 'Amazon注文情報',
  'aws.order.id': '注文ID',
  'aws.order.product': '製品タイプ',
  'aws.bind.success': '紐付け成功',
  'aws.bind.modal.create': '{appName}を作成',
  'aws.month': '{number} ヶ月',
  'aws.allBusiness': '全製品',
  'aws.order.status': '注文ステータス',
  'aws.aswStatus.refunded': '返金済み',
  'aws.aswStatus.expired': '期限切れ',
  'aws.aswStatus.subscribed': '購読中',
  'aws.aswStatus.upgraded': 'アップグレード済み',
  'aws.aswStatus.renewed': '自動更新済み',
  'aws.aswStatus.cancelled': 'キャンセル済み',
  'aws.aswStatus.refunded.tips':
    'この注文はAmazonで返金済みです。詳細については営業にお問い合わせください。',
  'aws.aswStatus.upgraded.tips':
    'この注文はAmazonでアップグレード済みです。EngageLabでアップグレード版を利用するには、営業にお問い合わせください。アップグレード内容は以下の通りです:',
  'aws.bindTips.cancelled': 'Amazonで注文がキャンセルされました',
  'aws.bindTips.unbind':
    'Amazonで注文が {status} 状態です。詳細については、営業にお問い合わせください',
  'aws.bindTips.unbind.status.refunded': '返金済み',
  'aws.bindTips.unbind.status.expired': '期限切れ',
  'aws.bindTips.unbind.status.upgraded': 'アップグレード済み',
  'aws.bindTips.unbind.status': '返金済み/期限切れ/アップグレード済み',
  'aws.nodata': 'データがありません',
  'aws.jumpEmail':
    '<a href="https://www.engagelab.com/console/email/#/email/{orgid}/sendSetting/domain" target="_blank">Email</a>に移動してドメインを設定してください',
};
